// 格式化工具：复用 src/utils/comUtil.js 的函数 + 本页面特有的金额展示
import {
  fmtPercent,
  fmtThousand,
  keepDecimal,
  transNum,
} from '@/utils/comUtil';

// 「¥X.X 万」字符串（用于表格中的金额）
export function formatWan(value) {
  if (value === null || value === undefined || isNaN(value)) {
    return '—';
  }
  const v = Number(value);
  if (v === 0) {
    return '¥0';
  }
  const wan = 10000;
  if (Math.abs(v) >= wan) {
    const val = Number(v) / wan;
    return `¥${fmtThousand(val, 1)} 万`;
  }
  return `¥${fmtThousand(v, 0)}`;
}

// 图表坐标轴：>=1万 转为「X.X万」，否则整数
export function formatAxisWan(value) {
  if (value === null || value === undefined || isNaN(value)) {
    return '';
  }
  const v = Number(value);
  const wan = 10000;
  if (Math.abs(v) >= wan) {
    return `${keepDecimal(v / wan, 1)}万`;
  }
  return Math.round(v).toString();
}

// KPI 大数字：超过 10000 用「X.X万」
export function formatKpiNumber(value, fixed = 1) {
  if (value === null || value === undefined || isNaN(value)) {
    return '—';
  }
  if (value === 0) {
    return '0';
  }
  return transNum(value, fixed);
}

// 百分比展示：「X.X%」（在 fmtPercent 上包一层，0 直接展示）
export function formatPercent(value, scale = 1) {
  if (value === null || value === undefined || isNaN(value)) {
    return '—';
  }
  if (value === 0) {
    return '0%';
  }
  return fmtPercent(value, scale);
}

// 千分位整数
export function formatThousand(value) {
  return fmtThousand(value, 0);
}
